/*
 * @Description: 学校迁移交割拦截页路由
 */
import { RouteRecordRaw } from 'vue-router'

const migrationRouter: Array<RouteRecordRaw> = [
  {
    path: '/migration',
    component: () => import(/* webpackChunkName: "Migration" */ '@/views/migration/index.vue'),
    name: 'Migration',
    meta: { title: '学校平台迁移' },
  },
]

export default migrationRouter
